import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Selection,
} from "devextreme-react/data-grid";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateContrNo } from "./Redux/workRecord";

export default function ProjectDropDownBox(props) {
  // const { workRecord } = props;
  const {
    projectDropDownBoxRef,
    //  currentEmployeeNo
    currentEmployee,
  } = props;

  // const workRecord = useSelector((state) => state.workRecord);
  const classifWork = useSelector((state) => state.workRecord.classifWork);
  // const { classifWork } = props;

  const startDate = useSelector((state) => state.workRecord.startDate);
  const contrNo = useSelector((state) => state.workRecord.contrNo);

  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const [projectDataSource, setProjectDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    if (classifWork != 1 || !startDate) {
      return;
    }

    // 늦게 도착한 응답이 다음 기록의 목록을 덮어쓰지 않도록 한다
    let cancelled = false;

    (async () => {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg?employeeNo=${userInfo.employeeNo}&date=${startDate}`
        );

        if (!cancelled && result.data) {
          setProjectDataSource(result.data);
        }
      } catch (error) {
        console.error(error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [classifWork, startDate]);

  const displayExpr = () => {
    if (!contrNo) {
      return null;
    }

    const key = Array.isArray(contrNo) ? contrNo[0] : contrNo;
    const project = projectDataSource?.find((p) => p.contrNo == key);

    // 목록이 아직 안 왔거나 목록에 없는 계약이어도 번호는 보여준다
    return project ? `[${key}] ${project.name}` : `[${key}]`;
  };

  const onValueChanged = (e) => {
    if (e.value) {
      // setContrNoValue(e.value);
      // dispatch(updateContrNo({ contrNo: e.value }));
      // workRecordFormRef.current.instance.updateData("contrNo", e.value);
      projectDropDownBoxRef.current.instance.option(
        "validationStatus",
        "valid"
      );
    }
  };

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setIsGridBoxOpened(e.value);
    }
  };

  const onSelectionChanged = (e) => {
    if (e.selectedRowKeys.length > 0) {
      dispatch(
        updateContrNo({
          contrNo: e.selectedRowKeys,
          currentDeselectedRowKeys: e.currentDeselectedRowKeys,
        })
      );

      setIsGridBoxOpened(false);
    }
  };

  const contentRender = () => {
    return (
      // <ProjectDataGrid
      //   projectDataSource={projectDataSource}
      //   setIsGridBoxOpened={setIsGridBoxOpened}
      //   formWorkRecordRef={formWorkRecordRef}
      // />
      <DataGrid
        keyExpr={"contrNo"}
        dataSource={projectDataSource}
        hoverStateEnabled={true}
        selectedRowKeys={
          typeof contrNo == "string" ? Array.of(contrNo) : contrNo
        }
        onSelectionChanged={onSelectionChanged}
        height={"100%"}
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode={"single"} />
        <Scrolling mode={"virtual"} showScrollbar="always" />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <Column dataField={"contrNo"} caption="Contract No." width={150} />
        <Column dataField={"name"} caption="Project Name" />
      </DataGrid>
    );
  };

  return (
    <DropDownBox
      ref={projectDropDownBoxRef}
      name="contrNo"
      // value={
      //   typeof workRecord.contrNo == "string"
      //     ? Array.of(workRecord.contrNo)
      //     : workRecord.contrNo
      // }
      value={contrNo}
      opened={isGridBoxOpened}
      valueExpr="contrNo"
      displayExpr={displayExpr}
      deferRendering={false}
      placeholder="Select a value..."
      contentRender={contentRender}
      disabled={classifWork && classifWork == 1 ? false : true}
      // readOnly={userInfo.employeeNo == currentEmployeeNo ? false : true}
      readOnly={
        userInfo.employeeNo == currentEmployee.employeeNo ? false : true
      }
      onValueChanged={onValueChanged}
      onOptionChanged={onOptionChanged}
    />
  );
}
